interface Props { fullScreen?: boolean; size?: number }

export default function LoadingSpinner({ fullScreen = false, size = 40 }: Props) {
  const spinner = (
    <div className="flex flex-col items-center gap-4">
      <div className="relative" style={{ width: size, height: size }}>
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent animate-spin"
          style={{ borderTopColor: 'var(--color-primary)', borderRightColor: 'var(--color-accent)' }}
        />
        <div
          className="absolute inset-2 rounded-full border-2 border-transparent animate-spin"
          style={{
            borderTopColor: 'var(--color-secondary)',
            animationDirection: 'reverse',
            animationDuration: '0.8s',
          }}
        />
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50"
        style={{ background: 'var(--color-bg)' }}>
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full py-16">
      {spinner}
    </div>
  );
}
